export const userSettingsAPIUrls = {
  getUsers: '/settings/users',
  getUser: '/settings/users/fetch',
  delete: '/settings/users/disable',
  save: '/settings/users/save',
  updateLicense: '/settings/users/updateLicense',
  image: {
    store: '/image/user/store',
    delete: '/image/user/delete',
  },
} as const;
